import { removeKey } from "@prismicio/editor-support/Object"
import {
  isSlicePrimaryContent,
  type SlicePrimaryContent
} from "@prismicio/types-internal/lib/content"
import type { SlicePrimaryWidget } from "@prismicio/types-internal/lib/customtypes"
import { useMemo } from "react"

import { GroupAndNestableWidgetSwitch } from "../GroupAndNestableWidgetSwitch"

type SlicePrimaryZoneContent = Readonly<Record<string, SlicePrimaryContent>>

interface SlicePrimaryZoneEditorProps {
  id: string
  readOnly: boolean
  slicePrimaryZone: Readonly<Record<string, SlicePrimaryWidget>>
  content: SlicePrimaryZoneContent
  onContentChange: (content: SlicePrimaryZoneContent) => void
}

export function SlicePrimaryZoneEditor(props: SlicePrimaryZoneEditorProps) {
  const { content, id, slicePrimaryZone, onContentChange, readOnly } = props

  const slicePrimaryWidgets = useMemo(
    () => Object.entries(slicePrimaryZone),
    [slicePrimaryZone]
  )

  return (
    <>
      {slicePrimaryWidgets.map(([slicePrimaryWidgetId, slicePrimaryWidget]) => {
        const widgetContent = content[slicePrimaryWidgetId]
        return (
          <GroupAndNestableWidgetSwitch
            key={slicePrimaryWidgetId}
            id={`${id}.${slicePrimaryWidgetId}`}
            readOnly={readOnly}
            widget={slicePrimaryWidget}
            content={
              isSlicePrimaryContent(widgetContent) ? widgetContent : undefined
            }
            onContentChange={(slicePrimaryWidgetContent) => {
              onContentChange(
                updateSlicePrimaryWidgetContent(
                  content,
                  slicePrimaryWidgetId,
                  slicePrimaryWidgetContent
                )
              )
            }}
          />
        )
      })}
    </>
  )
}

function updateSlicePrimaryWidgetContent(
  slicePrimaryZoneContent: SlicePrimaryZoneContent,
  slicePrimaryWidgetId: string,
  slicePrimaryWidgetContent: SlicePrimaryContent | undefined
): SlicePrimaryZoneContent {
  if (!slicePrimaryWidgetContent)
    return removeKey(slicePrimaryZoneContent, slicePrimaryWidgetId)

  return {
    ...slicePrimaryZoneContent,
    [slicePrimaryWidgetId]: slicePrimaryWidgetContent
  }
}
